module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGl2ZWxsb18xIiBkYXRhLW5hbWU9IkxpdmVsbG8gMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNTAgNTAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpub25lO3N0cm9rZTojMjMxZjIwO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MnB4O308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik00Mi42MSwxOC40MmMuNDYsOS44LTE2LDMwLjA4LTE2LDMwLjA4UzcuODYsMjkuODksNy40LDIwLjFhMTcuNjMsMTcuNjMsMCwxLDEsMzUuMjEtMS42OFoiLz48ZWxsaXBzZSBjbGFzcz0iY2xzLTEiIGN4PSIyNSIgY3k9IjE3LjkyIiByeD0iNy42NyIgcnk9IjcuNzMiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/front/assets/images/svg/black/icone_pin.svg
// module id = G+Az
// module chunks = 9